import React from 'react';
import SignUp from '../components/auth/SignUp';

const SignUpPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-neutral flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <img
          className="mx-auto h-16"
          src="/logoWithText.png"
          alt="AiLearn"
        />
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <SignUp />
      </div>
    </div>
  );
};

export default SignUpPage;
